import numeral from "numeral"

export const formatMoney = (value, showDecimals = true) => {
  return showDecimals ? numeral(value).format("$0,0.00") : numeral(value).format("$0,0")
}